// CognitiveLevel — Bloom's taxonomy 5-tier (per CONTENT_SPEC.md §2).
//
// Decision (Session 19K, signed CONTENT_SPEC v0.1.0):
//   - 5 levels (recall/understand/apply/analyze/evaluate)
//   - Bloom's 6th tier `create` deferred — exam-prep 场景几乎不出现
//   - Future addition allowed (z.enum 增值不破老数据)
//
// Pairs with `difficulty` (easy|medium|hard) — two orthogonal dimensions:
//   difficulty   = answer-rate proxy (how often students get it wrong)
//   cognitive    = thinking-depth (Bloom's hierarchy)
// A `recall` question can be `hard` (obscure terminology); an `apply` question
// can be `easy` (common scenario).
import { z } from 'zod';
export const CognitiveLevelSchema = z.enum([
    'recall', // 复述 / 列举 / 识别
    'understand', // 解释 / 转述 / 分类
    'apply', // 套用到新情境 / 计算
    'analyze', // 拆解关系 / 对比
    'evaluate', // 判断 / 论证选择
]);
export const ALL_COGNITIVE_LEVELS = CognitiveLevelSchema.options;
//# sourceMappingURL=cognitive-level.js.map